<template>
    <span class="ui-inline-jetton" v-bind:class="{
        'ui-inline-jetton--red': !hideColor && isMobile && isOut,
        'ui-inline-jetton--green': (!hideColor && isMobile && !isOut) || (!hideColor && transactionViewData === 'simple' && !isOut),
        'tx-mobile-content__price': isMobile,
    }">
        <span v-if="value !== undefined" class="ui-inline-jetton__value">
            <template v-if="showPlusMinusSign">
                {{isOut ? '&minus;' : '&plus;'}}
            </template>
            <!-- Split amount on simple table, so we can style int and fractional parts separately -->
            <template v-if="!isMobile && $store.state.transactionViewData === 'simple'">
                <tx-amount v-bind:amount="value" v-bind:decimals="decimals" />
            </template>
            <template v-else>
                {{$ton(value, decimals)}}
            </template>
        </span>

        <span v-if="address === null">GRAM</span>

        <ui-link v-else class="ui-inline-jetton__link tx-table-jetton-link-standart" v-bind:to="{ name: 'token', params: { address }}">
            {{ truncateTicker(ticker) }}
            <ui-round-image size="tiny" class="ui-inline-jetton__avatar"
                v-if="showImage"
                v-bind:src="imageData || image.w72"/>
        </ui-link>
    </span>
</template>

<script>
import { mapState } from 'vuex';
import TxAmount from '~/components/address/TxSimpleInlineAmount.vue';
import { isImpersonatingTicker, truncateTicker } from '../../helpers';

export default {
    methods: { truncateTicker },
    props: {
        address: String,
        value: String,
        name: String,
        decimals: Number,
        symbol: String,
        isOut: Boolean,
        showImage: Boolean,
        showSign: {
            type: Boolean,
            default: undefined,
        },
        hideColor: {
            type: Boolean,
            default: false,
        },
        imageData: String,
        image: {
            type: [Object, String],
            default: () => ({}),
        },
    },

    computed: {
        ticker() {
            // No metadata (the symbol is the address itself), or a jetton wearing
            // a ticker that belongs to the native coin or to the real USDT:
            if (this.symbol.length === 48 || isImpersonatingTicker(this.symbol, this.address)) {
                return this.address.substring(0, 3) + '…' + this.address.substring(45);
            }

            return this.symbol.toUpperCase();
        },

        showPlusMinusSign() {
            return this.showSign ?? this.isMobile;
        },

        ...mapState(['transactionViewData']),
    },
    components: { TxAmount },
};
</script>

<style lang="scss">
.ui-inline-jetton {
    display: inline-flex;
    align-items: center;
    text-transform: uppercase;
    &__value {
        margin-right: 4px;
    }
    &__link {
        display: flex;
        align-items: center;
    }
    &__avatar {
        margin: -4px -1px -4px 6px;
        width: 20px;
        height: 20px;
    }
    &--green {
        color: var(--badge-green-color);
    }
    &--red {
        color: var(--badge-red-color);
    }
    &--green, &--red {
        // if the amount is colored, the link should also be colored:
        .ui-inline-jetton__link {
            color: currentColor;
        }
    }
}
</style>
